import React, { useEffect, useState, useMemo } from 'react';
import { Table, Card, Button, Space, Typography, Input, Popconfirm, message, Rate, Row, Col } from 'antd';
import { SearchOutlined, DeleteOutlined, ReloadOutlined, StarOutlined, LikeOutlined, DislikeOutlined, MessageOutlined } from '@ant-design/icons';
import StatCard from '../components/StatCard';
import useReviewStore from '../store/reviewStore';

const { Title } = Typography;

const ReviewsPage = () => {
  const { reviews, loading, pagination, fetchReviews, deleteReview } = useReviewStore();
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetchReviews();
  }, [fetchReviews]);

  const handleDelete = async (id) => {
    try {
      await deleteReview(id);
      message.success("O'chirildi");
      fetchReviews();
    } catch {
      message.error('Xatolik yuz berdi');
    }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 60, sorter: (a, b) => a.id - b.id },
    { title: 'Xizmat ID', dataIndex: 'service_id', key: 'service_id' },
    { title: 'Foydalanuvchi ID', dataIndex: 'user_id', key: 'user_id' },
    {
      title: 'Reyting',
      dataIndex: 'rating',
      key: 'rating',
      render: (v) => <Rate disabled defaultValue={v} style={{ fontSize: 14 }} />,
      sorter: (a, b) => a.rating - b.rating,
    },
    { title: 'Izoh', dataIndex: 'comment', key: 'comment', ellipsis: true, render: (v) => v || '-' },
    {
      title: 'Sana',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (d) => d ? new Date(d).toLocaleDateString('uz-UZ') : '-',
    },
    {
      title: 'Amallar',
      key: 'actions',
      width: 80,
      render: (_, record) => (
        <Popconfirm title="O'chirishni tasdiqlaysizmi?" onConfirm={() => handleDelete(record.id)}>
          <Button type="text" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      ),
    },
  ];

  const filtered = reviews?.filter((r) =>
    !search || String(r.id).includes(search) || (r.comment || '').toLowerCase().includes(search.toLowerCase())
  );

  const stats = useMemo(() => {
    const list = reviews || [];
    const ratings = list.map(r => Number(r.rating || 0));
    return {
      total: list.length,
      avgRating: list.length > 0 ? (ratings.reduce((a, b) => a + b, 0) / list.length).toFixed(1) : 0,
      fiveStar: list.filter(r => Number(r.rating) === 5).length,
      oneStar: list.filter(r => Number(r.rating) <= 1).length,
    };
  }, [reviews]);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 8 }}>
        <Title level={3} style={{ margin: 0 }}>Sharhlar</Title>
        <Space wrap>
          <Input placeholder="Qidirish..." prefix={<SearchOutlined />} value={search} onChange={(e) => setSearch(e.target.value)} style={{ width: 200 }} allowClear />
          <Button icon={<ReloadOutlined />} onClick={() => fetchReviews()}>Yangilash</Button>
        </Space>
      </div>

      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col xs={24} sm={12} lg={6}>
          <StatCard title="Jami sharhlar" value={stats.total} icon={<MessageOutlined />} color="#4f46e5" loading={loading} />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <StatCard title="O'rtacha reyting" value={stats.avgRating} suffix="/ 5" icon={<StarOutlined />} color="#faad14" loading={loading} />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <StatCard title="5 yulduzli" value={stats.fiveStar} icon={<LikeOutlined />} color="#52c41a" loading={loading} />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <StatCard title="1 yulduzli" value={stats.oneStar} icon={<DislikeOutlined />} color="#ff4d4f" loading={loading} />
        </Col>
      </Row>

      <Card style={{ borderRadius: 12 }}>
        <Table
          dataSource={filtered}
          columns={columns}
          rowKey="id"
          loading={loading}
          scroll={{ x: 700 }}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            showSizeChanger: true,
            showTotal: (total) => `Jami: ${total}`,
          }}
          onChange={(pg) => fetchReviews({ page: pg.current, per_page: pg.pageSize })}
        />
      </Card>
    </div>
  );
};

export default ReviewsPage;
